import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './Layout.css';

const Layout = ({ hideHeaderContactButton = false }) => {
  return (
    <div className='app-layout'>
      <a href='#main-content' className='skip-link'>
        Skip to main content
      </a>
      <Header hideContactButton={hideHeaderContactButton} />
      <main id='main-content' className='app-main-content'>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
